import { useEffect, useState } from 'react';
import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { RegulationTabs } from '../../components/Tab/Tabs';
import { fetchGet } from '../../hooks/fetch';

export default function Terms() {
	const pageName = '이용약관';
	const [tabsData, setTabsData] = useState([]);

	function getPage() {
		fetchGet(
			`/regulation?type=TERMS`,
			(json) => setTabsData(json)
		)
	}

	useEffect(() => {
		getPage();
	}, []);

	return (
		<main id="policy-page-wrap" className="terms">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<div className="page-content">
					<RegulationTabs tabsData={tabsData} className="gs-sub-tab-con line" />
				</div>
			</Container>
		</main>
	);
}
